import React from 'react';

const Error = ({ heading }: { heading: string }) => (
  <h2
    className='mt-16 text-4xl'
    id='error-message'
  >{heading}</h2>
);

export default Error;
